import { get, put } from "../../utils/httpClient";

const rolePermissionService = () => {
  const prefixApi = "duedates/rolepermissions";

  const getRolePermissions = async () => {
    return await get(`/${prefixApi}`);
  };

  const getRolePermissionsByRoleId = async (id) => {
    return await get(`/${prefixApi}/role/${id}`);
  };

  const updateRolePermissions = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  return {
    getRolePermissions,
    getRolePermissionsByRoleId,
    updateRolePermissions,
  };
};

export default rolePermissionService;
